module.exports = __webpack_public_path__ + "img/cbe7fb3.svg";